import { IPlayerState } from '../../../State/Player/IPlayerState';
import IPlayerData from '../../IPlayerData';
import { restoreNumber } from '../../ParseHelper';
import PlayerProperty from '../PlayerProperty';

export default class Keys extends PlayerProperty<
    number,
    {
        keys: number;
    }
> {
    public readonly defaultValue: number = 0;

    public restore(playerEndpointData: IPlayerData): number {
        // Do not allow negative values (remnant of v1 legacy data).
        return Math.max(
            0,
            restoreNumber(playerEndpointData.keys, this.defaultValue)
        );
    }

    public save(playerStateData: IPlayerState) {
        return { keys: playerStateData.keys };
    }

    public isChanged(
        playerStateData: IPlayerState,
        playerEndpointData: IPlayerData
    ): boolean {
        return playerStateData.keys !== playerEndpointData.keys;
    }
}
